import { SidebarMenuItem } from "../../Types/Layout.type";

export const menuList: SidebarMenuItem[] = [
    {
        title: "General",
        lanClass: "lan-1",
        items: [
           
        ],
    },
    {
        // title: "Application",
        items: [
           
            { path: `${process.env.PUBLIC_URL}/weeklybooking`, icon: "Tick-square", type: "link", title: "Weekly Booking", id: 12 },
            { path: `${process.env.PUBLIC_URL}/token`, icon: "Calendar", type: "link", title: "Token", id: 13 },
            { path: `${process.env.PUBLIC_URL}/finalverification`, icon: "Edit", type: "link", title: "Medicine details", id: 15, bookmark: true, },
            { path: `${process.env.PUBLIC_URL}/approvedlist`, icon: "Document", type: "link", title: "Approved Medicines History", id: 14, bookmark: true, },

            { path: `${process.env.PUBLIC_URL}/medicinetable`,icon: "Chart", type: "link", title: "Medicine status", id: 16 },
            { path: `${process.env.PUBLIC_URL}/tokencount`, icon:"Category" , type:"link", title:"Token count", id:18 },
            { path: `${process.env.PUBLIC_URL}/purchaseteam`,  icon:"Profile" , type:"link", title:"Purchase Team", id:19 },
            { path: `${process.env.PUBLIC_URL}/registeremployee`, icon: "Profile", type: "link", title: "Register Employee", id: 20 },
            { path: `${process.env.PUBLIC_URL}/medicalrepdetails`, icon:"Bag" , type:"link", title:"Medical Reps", id:17 },
            { path: `${process.env.PUBLIC_URL}/appointmentdates`, icon:"Calendar" , type:"link", title:"Appointment Dates", id:21 },
            { path: `${process.env.PUBLIC_URL}/appointment`, icon:"Calendar" , type:"link", title:"Appointment Dates", id:22 },
            { path: `${process.env.PUBLIC_URL}/division`, icon:"Bookmark" , type:"link", title:"Divisions", id:23 },
            { path: `${process.env.PUBLIC_URL}/viewtax`, icon:"Activity" , type:"link", title:"Tax", id:24 },

            


        ],
    },
   
];
